<template>
    <div class="content-full-h remove-top-margin" v-cloak>
        <video :src="videoSrcForDevice('operational-planning')" id="video" autoplay loop></video>
        
        <sidebar>
            <h3 v-html="$t('operational_planning.nav_header')"></h3>

            <ul>
                <li v-html="$t('operational_planning.nav_1')"></li>
            </ul>
        </sidebar>
    </div>
</template>

<script>

import Sidebar from './Sidebar.vue';

export default {

    components: {
        'sidebar': Sidebar,
    },

    data: function() {
        return {
        }
    },

    methods: {
        videoSrcForDevice: function(videoName) {
            let screenWidth = window.screen.width;

            if(screenWidth <= 1024) {
                return this.videoSrc(videoName, 'ipad_old');
            } else if(screenWidth == 1080) {
                return this.videoSrc(videoName, 'ipad_new');
            } else if(screenWidth == 1112 || screenWidth == 1366 || screenWidth == 1194) {
                return this.videoSrc(videoName, 'ipad_air');
            } else {
                return this.videoSrc(videoName, 'desktop');
            }
        },

        videoSrc: function(videoName, device) {
            if(device == 'desktop')
                return require(`../assets/videos/${videoName}_${this.$i18n.locale}_${device}.webm`);
            else 
                return require(`../assets/videos/${videoName}_${this.$i18n.locale}_${device}.mp4`);
        },
    },

    mounted() {
        this.$root.showNav = false;
    },

    unmounted() {
        this.$root.showNav = true;
    }
}

</script>